import { useId } from 'react';

import { DANGER_RED } from '../../primitives';

export interface CancelReasonFieldProps {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  /** Show the required-field error. */
  showMissing: boolean;
}

export function CancelReasonField({
  value,
  onChange,
  onBlur,
  showMissing,
}: CancelReasonFieldProps) {
  const id = useId();
  return (
    <>
      <label htmlFor={id} style={{ display: 'block', marginTop: 14, fontSize: 13 }}>
        Reason{' '}
        <span aria-hidden="true" style={{ color: DANGER_RED }}>
          *
        </span>
      </label>
      <textarea
        id={id}
        className="nb-input"
        rows={3}
        maxLength={500}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        required
        aria-invalid={showMissing}
        style={{ width: '100%', marginTop: 4 }}
      />
      {showMissing && (
        <div role="alert" style={{ color: DANGER_RED, fontSize: 12, marginTop: 4 }}>
          Enter a reason for cancelling.
        </div>
      )}
    </>
  );
}
